import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageCropper from '../../components/ImageCropper';

const CropImage: React.FC = () => (
  <ToolLayout
    title="Crop Image Online Free - Trim & Cut Images | AllTools"
    description="Crop images online with precision. Use preset ratios or custom crop areas. Free image cropping tool."
    canonicalPath="/crop-image"
  >
    <ImageCropper />
  </ToolLayout>
);

export default CropImage;
